<template>
  <div ref="otpCont">
    <KInput
      type="text"
      class="otp"
      v-for="(el, ind) in digits"
      :key="el+ind"
      v-model="digits[ind]"
      :autofocus="ind === 0"
      maxlength="1"
      @keydown="handleKeyDown($event, ind)"
      :class="{bounce: digits[ind] !== null}"
      :error="error"
    />
  </div>
</template>

<script setup>
import { ref, reactive, defineEmits, defineProps } from 'vue';
import KInput from '@components/inputs/input.vue';

const props = defineProps({
  default: String,

  digitCount: {
    type: Number,
    default: 5,
  },

  error: {
    type: Boolean,
    default: false,
  },
});

const digits = reactive([]);

if (props.default && props.default.length === props.digitCount) {
  for (let i = 0; i < props.digitCount; i += 1) {
    digits[i] = props.default.charAt(i);
  }
} else {
  for (let i = 0; i < props.digitCount; i += 1) {
    digits[i] = null;
  }
}

const otpCont = ref(null);

const emit = defineEmits(['input']);

const isDigitsFull = () => {
  for (const elem of digits) {
    if (elem == null || elem == undefined) {
      return false;
    }
  }

  return true;
};

const handleKeyDown = (event, index) => {
  if (event.key !== 'Tab'
    && event.key !== 'ArrowRight'
    && event.key !== 'ArrowLeft'
  ) {
    event.preventDefault();
  }

  if (event.key === 'Backspace') {
    digits[index] = null;

    if (index !== 0) {
      (otpCont.value.children)[index - 1].getElementsByTagName('input')[0].focus();
    }
  } else if ((/^([0-9])$/).test(event.key)) {
    digits[index] = event.key;

    if (index !== props.digitCount - 1) {
      (otpCont.value.children)[index + 1].getElementsByTagName('input')[0].focus();
    }
  }

  emit('input', digits.join(''));
  // emit('keydown', event);
};
</script>

<style scoped lang="scss">
.otp {
  width: calc(var(--grid-unit) * 4.5);
  display: inline-block;
  margin: 0 calc(var(--grid-unit) * .5);

  @media screen and (min-width: 768px) {
    margin: 0 calc(var(--grid-unit) * 1.5);
  }

  :deep(.k-input) {
    height: 42px;
    display: inline-block;
  }
}
</style>
